import { useStats } from '../../lib/ctx/stats'
import { StatsSectionShareButton } from '../shared'
import { AuthorsShareCard } from './AuthorsShareCard'

export const AuthorsShareButton = () => {
  const theme = useStats((s) => s.theme)

  return (
    <StatsSectionShareButton sectionBgColor={theme.bg100} type="authors">
      <AuthorsShareCard />
    </StatsSectionShareButton>
  )
}
